// 插件路由
const routes = [
	{ 
        path: '/debtbig', 
        component: () => import(/* webpackChunkName: "debt" */ '~/addon/debtbig/pages/debt.vue') 
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/debtbig/router/index.js